/** Content type returned by a request header. */
export const contentType = {
    FORM_DATA: 'multipart/form-data',
    JSON: 'application/json',
}
